export default __webpack_public_path__ + "static/media/todo1.af910ba9.PNG";